import RadioGroupField from './component'

export default RadioGroupField
